<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-ven-gerencial-integrado") {
            next({ name: "gerencial-integrado-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-ven-gerencial-integrado") {
            this.$router.push({ name: "gerencial-integrado-list" });
        }
    },
};
</script>